var map = {
	"./Login.svg": "98f2",
	"./LogoText.svg": "83c0",
	"./access.svg": "359f",
	"./afiliateIcon.svg": "089b",
	"./analyticsEmptyState.svg": "decf",
	"./analyticsImage.svg": "250a",
	"./arrowUp.svg": "d9fc",
	"./arrow_carousel.svg": "c888",
	"./back2.svg": "e6cd",
	"./blueSadFeeling.svg": "2a18",
	"./boletoIcon.svg": "eb4c",
	"./browserDRM.svg": "a3aa",
	"./cc_listing.svg": "d3e0",
	"./cc_tooltip.svg": "55c6",
	"./checkbox-blank.svg": "cdd2",
	"./checkbox-filled.svg": "e050",
	"./closed-captions.svg": "ecaf",
	"./credit_blue_darken_icon.svg": "0d2a",
	"./credit_blue_icon.svg": "255f",
	"./credit_green_icon.svg": "49a2",
	"./credit_grey_icon.svg": "13c7",
	"./credit_red_danger_icon.svg": "0c5f",
	"./credit_red_icon.svg": "aeb8",
	"./credit_small_icon.svg": "2cd6",
	"./crown.svg": "7cd5",
	"./cursor.svg": "1e92",
	"./dub_cc.svg": "60cb",
	"./dub_listing.svg": "b91e",
	"./dubbing.svg": "d62c",
	"./ebook.svg": "417b",
	"./ebookModal.svg": "33ce",
	"./editPencil.svg": "6ed1",
	"./external.svg": "ef87",
	"./generatingAiSubtitle.svg": "4af6",
	"./headerImage.svg": "a535",
	"./icon-video-speed.svg": "77af",
	"./icon_pix.svg": "b6d4",
	"./link.svg": "6bb3",
	"./link_dark.svg": "b095",
	"./loadingAi/loadingAiStep1.svg": "42b1",
	"./loadingAi/loadingAiStep2.svg": "b0f9",
	"./loadingAi/loadingAiStep3.svg": "e0a2",
	"./loadingAi/loadingAiStep4.svg": "6d36",
	"./loadingAi/loadingAiStep5.svg": "d288",
	"./loadingAi/loadingAiStep6.svg": "4520",
	"./login-0.svg": "89f2",
	"./login-1.svg": "3f5b",
	"./login-2.svg": "87c7",
	"./login-circle.svg": "e34c",
	"./login-points.svg": "093f",
	"./loginBackground1.svg": "53a2",
	"./loginBackgroundImage1.svg": "36b7",
	"./loginImage1.svg": "f464",
	"./loginImage2.svg": "b5d4",
	"./loginImage3.svg": "a2a6",
	"./logo-panda-name.svg": "6806",
	"./logoBlack.svg": "6a0d",
	"./logoWhite.svg": "3a24",
	"./mastercardLogo.svg": "190a",
	"./mindMap.svg": "e27c",
	"./mindMapModal.svg": "0dda",
	"./newFolder.svg": "27c6",
	"./nfeDisabled.svg": "dd0b",
	"./nfeEnabled.svg": "053d",
	"./noFilesImage.svg": "a6dc",
	"./notifications.svg": "4170",
	"./onboardingImage1.svg": "88b4",
	"./onboardingImage2.svg": "08d1",
	"./onboardingImage3.svg": "113a",
	"./pandaChip.svg": "4409",
	"./pandaHappy.svg": "b5a2",
	"./pandaLogo.svg": "523f",
	"./pandaLogoDarkTheme.svg": "e548",
	"./pandaMainLogo.svg": "9cd2",
	"./pandaMark.svg": "3eac",
	"./pandaSad.svg": "35f7",
	"./pandaStroke.svg": "9e61",
	"./pandaToolbarDark.svg": "de0a",
	"./preload-en.svg": "c7f4",
	"./preload-pt.svg": "bbf1",
	"./preparingAccount.svg": "0e35",
	"./progressIcon.svg": "42fe",
	"./purchaseFailed.svg": "bb33",
	"./purchaseSuccess.svg": "5afa",
	"./robot.svg": "2b1c",
	"./s3.svg": "d802",
	"./sendButton-disabled.svg": "b0481",
	"./sendButton.svg": "c382",
	"./summary.svg": "d927",
	"./techLines.svg": "2a31",
	"./thumbUploadIcon.svg": "9115",
	"./undraw_live.svg": "37e6",
	"./undraw_partying.svg": "ea1e",
	"./undraw_real_time_analytics.svg": "158c",
	"./upload.svg": "c118",
	"./uploadIcon.svg": "0752",
	"./video_file.svg": "6dff",
	"./videosIcon.svg": "3976",
	"./vimeoicon.svg": "e988",
	"./visaCard.svg": "d46f",
	"./waitingLive.svg": "8f87",
	"./warningIcon.svg": "4772",
	"./watchLive.svg": "73a9",
	"./ytb.svg": "945f",
	"./zoomInIcon.svg": "8b4c",
	"./zoomOutIcon.svg": "bf66",
	"./zoomToFitIcon.svg": "a5b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";